import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	enterFullScreen: {
		id: 'platform.fullscreen-button.enter-full-screen',
		defaultMessage: 'Enter full screen',
		description: 'Tooltip content for enter full screen button',
	},
	exitFullScreen: {
		id: 'platform.fullscreen-button.exit-full-screen',
		defaultMessage: 'Exit full screen',
		description: 'Tooltip content for exit full screen button',
	},
	fullScreenShortcut: {
		id: 'platform.fullscreen-button.full-screen-shortcut',
		defaultMessage: '<inline>Z</inline>',
		description: 'Shortcut for entering or exiting full screen mode',
	},
	fullScreenShortcutPlain: {
		id: 'platform.fullscreen-button.full-screen-shortcut-plain',
		defaultMessage: 'Z',
		description: 'Plain text shortcut for accessibility',
	},
	fullScreenShortcutNew: {
		id: 'platform.fullscreen-button.full-screen-shortcut-new',
		defaultMessage:
			'<inline>Ctrl</inline> + <inline>{isMacOs, select, true {Option} other {Alt}}</inline> + <inline>Z</inline>',
		description:
			'Alt + Meta + Z shortcut for entering or exiting full screen mode with platform-specific keys',
	},
	fullScreenShortcutNewPlain: {
		id: 'platform.fullscreen-button.full-screen-shortcut-new-plain',
		defaultMessage: 'Ctrl + {isMacOs, select, true {Option} other {Alt}} + Z',
		description: 'Plain text Alt + Meta + Z shortcut for accessibility with platform-specific keys',
	},
});
